const CATEGORY = 'Pembahasan'

export const explanation = track => ({
    filterAnswerType(type) {
        track(CATEGORY, 'Filter tipe jawaban', type)
    },

    filterField(field) {
        track(CATEGORY, 'Filter bidang', field)
    }
})
